import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print-pltshipment',
  templateUrl: './print-pltshipment.component.html',
  styleUrls: ['./print-pltshipment.component.css']
})
export class PrintPltshipmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/print-pltshipment/print-pltshipment.component.ts